<template>
  <section
    id="faqs"
    data-aos="fade"
    class="bg-[#f9f5f0] py-24 relative overflow-hidden sm:py-32"
  >
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -top-4 w-full"
      height="32"
      width="375"
    />
    <img
      :src="BeigeBorder"
      alt="Beige border squiggle"
      class="absolute h-8 -bottom-4 -scale-100 w-full"
      height="32"
      width="375"
    />
    <img
      :src="Squiggle"
      alt="Squiggle purple line"
      class="absolute -top-8 left-0 w-full opacity-5 h-[120%]"
      height="375"
      width="375"
    />
    <div class="mx-auto max-w-7xl px-6 relative lg:px-8">
      <div
        class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-12 lg:mx-0 lg:max-w-none lg:grid-cols-5"
      >
        <div data-aos="fade-up" class="col-span-2 relative pb-4">
          <h2 class="text-base/7 font-semibold text-purple-600 relative">
            Questions & Answers
          </h2>
          <p
            class="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl"
          >
            Frequently asked questions
          </p>
        </div>
        <div class="col-span-full mb-4">
          <details
            v-for="item in faqs"
            :key="item.id"
            data-aos="fade-up"
            name="accordion"
            class="transition-all border-b last-of-type:border-b-0 border-gray-800/20"
          >
            <summary
              class="transition-all p-4 text-base/7 font-semibold flex justify-between items-center gap-2.5 cursor-pointer md:text-lg/7 lg:py-6"
            >
              <p>
                {{ item.title }}
              </p>
              <i class="fa-solid fa-chevron-down"></i>
            </summary>
            <div class="details-content-wrapper text-lg/7">
              <div class="pb-4">
                <p>{{ item.body }}</p>
              </div>
            </div>
          </details>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import BeigeBorder from "/graphics/expert-top.svg";
import Squiggle from "/graphics/purple/squiggle-5.svg";

const faqs = [
  {
    id: 1,
    title: "Who is the Juniper Education app for?",
    body: "The Juniper Education mobile app is designed for both teachers and parents. Based on your login credentials, the app shows you the most relevant information. Teachers can access features like comms, awards, observations and attendance, while parents can make bookings, view their children's achievements and stay up to date with school news.",
  },
  {
    id: 2,
    title: "How do I get access to the app?",
    body: "You’ll receive an invite from your child’s school. Follow the link in the email to create your account, then download and log in. ",
  },
  {
    id: 3,
    title: "Is the app free to use?",
    body: "Yes! The app is completely free for parents. There are no hidden fees or in-app purchases.",
  },
  {
    id: 4,
    title: "What devices does the app work on?",
    body: "The app is available on both iOS and Android devices. Just search for it in the App Store or Google Play Store.",
  },
  {
    id: 5,
    title: "What kind of updates will I receive?",
    body: "Teachers will be able to share moments throughout the day including photos, badges and points. Your child's school may also send app messages and events for you to enroll your child on to. ",
  },
];
</script>

<style>
::details-content {
  transition: all 0.5s ease, content-visibility 0.5s allow-discrete;
  height: 0;
  overflow: clip;
}

@supports (interpolate-size: allow-keywords) {
  :root {
    interpolate-size: allow-keywords;
  }

  ::details-content {
    padding-inline: 1rem;
  }

  [open]::details-content {
    height: auto;
    padding: 0.5rem 1rem;
  }
}
@supports not (interpolate-size: allow-keywords) {
  [open]::details-content {
    height: 150px; /* In the future to be replaced by `height: auto` */
    overflow-y: scroll; /* In case the contents should be taller than 150px */
  }
}

details[open] {
  background-color: white;
}

details[open] > summary > i {
  transform: rotate(180deg);
}
</style>
